import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/node_modules/next-auth/react.js");
